
































import {Vue, Component, PropSync} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {Mall} from 'supporter';
import CompSelectBox from '@/components/common/CompSelectBox.vue';

@Component({
  components: {
    CompSelectBox
  }
})
export default class OrderRegisterTypeSelect extends Vue{
  private orderRegisterTypes = [
    {value: 'NORMAL', name: 'ORDER_ORDER_CONTENT_TOP_ORDER_REGISTER_NORMAL'},
    {value: 'ADMIN', name: 'ORDER_ORDER_CONTENT_TOP_ORDER_REGISTER_ADMIN'},
    {value: 'ARIEL', name: 'ORDER_ORDER_CONTENT_TOP_ORDER_REGISTER_ARIEL'},
    {value: 'RECURRING_PAYMENT', name: 'ORDER_ORDER_CONTENT_TOP_ORDER_REGISTER_RECURRING_PAYMENT'},
  ];

  @Getter('mall/malls')
  private malls: Mall[]

  @PropSync('orderRegisterType')
  private orderRegisterTypeSync!: string;

  @PropSync('includesReservation')
  private includesReservationSync!: boolean;
}
